import styled from 'styled-components';


export const Icon = styled.img`
  width: ${(props) => props.size};
  height: ${(props) => props.size};
  margin: ${(props) => props.margin || '0 10px'};

  :hover {
    cursor: pointer;
  }
`;

export const IconButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: none;
  padding: 4px;
  cursor: pointer;
  color: ${(props) => props.theme.colors.label};
  transition: color 150ms ease;
  &:hover {
    color: ${(props) => props.theme.colors.lightblue};
  }
`;

export const TrashButtonIcon = styled.button`
  position: relative;
  margin: 0;
  padding: 0;

  &:disabled {
    cursor: not-allowed;
    opacity: 0.7;
  }

  svg {
    width: ${(props) => props.size}px;
    height: ${(props) => props.size}px;
    transition: all 0.2s ease-in-out;
    fill: ${(props) => props.theme.colors.disabled};

    &:hover {
      fill: ${(props) => props.theme.colors.darkerblue};
    }
  }

  cursor: pointer;
  background: transparent;
`;

export const Label = styled.label`
  font-size: 14px;
  font-weight: ${(props) => (props.weight ? props.weight : 600)};
  color: ${(props) => (props.color ? props.color : props.theme.colors.label)};
  padding-right: ${(props) => (props.padding ? props.padding : '0px')};
`;
